import type { FormStepProps } from '@redventures/odyssey'
import type { RefObject } from 'react'
import AddressAndMover from './AddressAndMover'
import { addressStepFamily } from '../../constants/questions/addressAndMover'
import BillUploadQuestion from './BillUploadQuestion'
import CheckboxQuestion from './CheckboxQuestion'
import HomeInfo from './HomeInfo'
import MonthlyEnergy from './MonthlyEnergy'
import RadioGroup from './RadioGroup'
import TemperatureQuestion from './TemperatureQuestion'
import TextQuestion from './TextQuestion'
import type { FormStepRef } from './formStepRef'

const RADIO_GROUP_STEP_NAMES = new Set([
  'radioGroup',
  'interstitialRadioGroup',
  'moverSwitcherRadioGroup',
  'texasMoveRadioGroup',
  'vehicleChargeRadioGroup',
  'topRatedProviderRadioGroup',
  'termChoiceRadioGroup',
])

export function QuestionStepBody({
  stepName,
  propsWithTrackingSteps,
  formStepRef,
}: {
  stepName: string
  propsWithTrackingSteps: FormStepProps
  formStepRef: RefObject<FormStepRef | null>
}) {
  if (addressStepFamily().stepNames.has(stepName)) {
    return (
      <AddressAndMover
        {...propsWithTrackingSteps}
        ref={formStepRef}
      />
    )
  }

  if (stepName === 'homeInfo') {
    return (
      <HomeInfo
        {...propsWithTrackingSteps}
        ref={formStepRef}
      />
    )
  }

  if (RADIO_GROUP_STEP_NAMES.has(stepName)) {
    return <RadioGroup {...propsWithTrackingSteps} />
  }

  if (stepName === 'monthlyEnergy') {
    return <MonthlyEnergy {...propsWithTrackingSteps} />
  }

  if (stepName === 'textQuestion') {
    return <TextQuestion {...propsWithTrackingSteps} />
  }

  if (
    stepName === 'householdIncludesCheckboxGroup' ||
    stepName === 'energyPlanIncludesCheckboxGroup'
  ) {
    return <CheckboxQuestion {...propsWithTrackingSteps} />
  }

  if (stepName === 'temperature') {
    return <TemperatureQuestion {...propsWithTrackingSteps} />
  }

  if (stepName === 'uploadBill') {
    return (
      <BillUploadQuestion
        {...propsWithTrackingSteps}
        ref={formStepRef}
      />
    )
  }

  return null
}
